export default __webpack_public_path__ + "static/media/Apex Supply Chain.215b8b50.png";